import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ImmomioIconName } from '@resident-nx/shared';
import { IconWebComponent } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';
import { FormFieldComponent } from '../../../molecules/form/form-field.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'rs-web-ida-chatbot-consent-panel',
  templateUrl: './ida-chatbot-consent-panel.html',
  styleUrl: './ida-chatbot-consent-panel.scss',
  imports: [IconWebComponent, ImmomioButtonComponent, FormFieldComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IdaChatbotConsentPanelWebComponent {
  protected readonly immomioIconName = ImmomioIconName;

  legalText = input.required<string>();

  consentAccepted = output();
  closed = output();
}
